import { WRAPPER_LINK_SLUG, LINK_SLUG, BUTTON_SLUG } from "@/lib/elements/constants";
import { parentNodesReduce } from "@/lib/tree/tree";
import { documentStore } from "@/store/store";
import { TreeNode } from "@/types/tree";

export const LINK_ELEMENTS_AND_PROPERTY_PATHS : ElementWithEditableLinks[] = [
    {
        elementSlug: WRAPPER_LINK_SLUG,
        linkPropertyPaths: ['content.content.link'],
    },
    {
        elementSlug: LINK_SLUG,
        linkPropertyPaths: ['content.content.link'],
    },
    {
        elementSlug: BUTTON_SLUG,
        linkPropertyPaths: ['content.content.link'],
    },
    {
        elementSlug: 'EssentialElements\\PricingTable',
        linkPropertyPaths: ['content.content.button.link'],
    }
];

type ElementWithEditableLinks = {
    elementSlug: string;
    linkPropertyPaths: string[];
}

export function isLinkElement(elementSlug: string): boolean {
    return LINK_ELEMENTS_AND_PROPERTY_PATHS.some(item => item.elementSlug === elementSlug);
}

export function getLinkPropertyPathsForElement(elementSlug: string): string[] | undefined {
    return LINK_ELEMENTS_AND_PROPERTY_PATHS.find(item => item.elementSlug === elementSlug)?.linkPropertyPaths;
}

export function isChildOfLinkElement(node: TreeNode) {
  return parentNodesReduce(
    (node, acc) => {
      if (isLinkElement(node.data.type)) {
        return true;
      }
      return acc;
    },
    documentStore.document.tree,
    node,
    false
  );
}

export function getNearestParentLinkElement(node: TreeNode): TreeNode | undefined {
  return parentNodesReduce(
    (node: TreeNode, acc: TreeNode | undefined) => {
      if (isLinkElement(node.data.type)) {
        return node;
      }
      return acc;
    },
    documentStore.document.tree,
    node,
    undefined
  );
}

